export default "__VITE_ASSET__Cg6r_wOz__"